import { orderScooterAction } from "./action"

export const initialState = {
  currentPath: "scooter",
  replyData: false,
  replyOrderData: false,
  ShoppingCartData: {
    TotalAmount: 0,
    DiscountAmount: 0,
    Product: [],
  },
  PDIStoreOptions: [],
  UserData: {
    Birthday: [0, 0, 0],
  },
  allFormData: {
    ShoppingList: {},
    OrderingInfo: {},
    SubsidyLicensing: {},
    PaymentInfo: {},
    SubsidyData: {
      subsidyType: 0,
      subsidyUnit: 0,
      subsidyCounty: 0,
      subsidyCountyName: "",
      localSubsidyName: "",
      localSubsidyType: 0,
      entrust: null,
    },
  },
  licensingCenterOptions: [],
  corporateCarIndividualLicense: 0,
  initPostData: null,
}

export function orderScooterReducer(state = initialState, action) {
  switch (action.type) {
    case orderScooterAction.SET_ORDER_UI_STATE: {
      return Object.assign({}, state, action.payload)
    }

    case orderScooterAction.SET_FORM_DATA: {
      return {
        ...state,
        allFormData: {
          ...state.allFormData,
          [`${action.payload.name}`]: {
            ...Object.assign({}, state.allFormData[`${action.payload.name}`], action.payload.data),
          },
        },
      }
    }

    case orderScooterAction.RELOAD_SHOPCART: {
      let newObj = { ...state }
      newObj.ShoppingCartData = action.payload

      return newObj
    }

    default:
      return state
  }
}
